import VisibilityIcon from "@mui/icons-material/Visibility";
import {
	Box,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
} from "@mui/material";
import { useState } from "react";
import {
	Datagrid,
	DateField,
	ExportButton,
	FilterButton,
	List,
	SelectInput,
	TextField,
	TextInput,
	TopToolbar,
	useRecordContext,
} from "react-admin";

const deadLetterEventFilters = [
	<TextInput key="source" label="Source" source="source" alwaysOn />,
	<TextInput key="appId" label="App ID" source="appId" />,
	<TextInput
		key="transactionId"
		label="Transaction ID"
		source="transactionId"
	/>,
	<SelectInput
		key="resolved"
		label="Resolved"
		source="resolved"
		choices={[
			{ id: "true", name: "Yes" },
			{ id: "false", name: "No" },
		]}
	/>,
];

const ListActions = () => (
	<TopToolbar>
		<FilterButton />
		<ExportButton />
	</TopToolbar>
);

const JsonViewerButton = ({
	data,
	title,
}: {
	data: unknown;
	title: string;
}) => {
	const [open, setOpen] = useState(false);

	if (!data) return <span>-</span>;

	return (
		<>
			<IconButton size="small" onClick={() => setOpen(true)}>
				<VisibilityIcon fontSize="small" />
			</IconButton>
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				maxWidth="md"
				fullWidth
			>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					<Box
						component="pre"
						sx={{
							backgroundColor: "#f5f5f5",
							p: 2,
							borderRadius: 1,
							overflow: "auto",
							maxHeight: 400,
							fontSize: "0.875rem",
						}}
					>
						{typeof data === "string" ? data : JSON.stringify(data, null, 2)}
					</Box>
				</DialogContent>
			</Dialog>
		</>
	);
};

const PayloadField = () => {
	const record = useRecordContext();
	return <JsonViewerButton data={record?.payload} title="Payload" />;
};

const ResolvedChip = () => {
	const record = useRecordContext();
	if (!record) return null;

	const isResolved = !!record.resolvedAt;

	return (
		<Box
			sx={{
				display: "inline-block",
				px: 1,
				py: 0.5,
				borderRadius: 1,
				backgroundColor: isResolved ? "#4caf50" : "#f44336",
				color: "white",
				fontSize: "0.75rem",
				fontWeight: 500,
				textTransform: "uppercase",
			}}
		>
			{isResolved ? "Resolved" : "Unresolved"}
		</Box>
	);
};

export const DeadLetterEventList = () => (
	<List
		filters={deadLetterEventFilters}
		actions={<ListActions />}
		sort={{ field: "createdAt", order: "DESC" }}
	>
		<Datagrid bulkActionButtons={false}>
			<DateField source="createdAt" label="Created" showTime />
			<TextField source="source" label="Source" />
			<ResolvedChip />
			<TextField source="reason" label="Reason" />
			<TextField source="appId" label="App ID" emptyText="-" />
			<TextField source="transactionId" label="Transaction ID" emptyText="-" />
			<PayloadField />
			<DateField
				source="resolvedAt"
				label="Resolved At"
				showTime
				emptyText="-"
			/>
		</Datagrid>
	</List>
);
